export const loadConfirmationFormPanelSx = {
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  bgcolor: '#f0f0f0',
} as const

export const loadConfirmationTabContentSx = {
  px: 0,
  pt: 0,
  pb: 0,
  minHeight: '100%',
} as const
